import { useQuery } from "@tanstack/react-query";
import { opac } from "./query";

export function GetOPACLibrary() {
  return useQuery(opac.getOPACLibrary());
}

export function GetMaterialTypeByLibraryID(Id?: string | number | null) {
  return useQuery({
    ...opac.getMaterialTypeByLibraryID(Id!),
    enabled: !!Id && Id !== 0 && Id !== "0",
  });
}

export function GetOPACLanguage() {
  return useQuery({
    ...opac.getOPACLanguage(),
  });
}

export function GetOPACInstitute() {
  return useQuery({
    ...opac.getOPACInstitute(),
  });
}

export function GetOPACDepartmentbyInstituteID(id?: string | number | null) {
  return useQuery({
    ...opac.getOPACDepartmentbyInstituteID(id!),
    enabled: !!id && id !== 0 && id !== "0",
  });
}

